export const typesOrders = {
  'Anuladas': '09',
  'Cerradas': '80',
  'NoFacturables': '85',
};


export const COLORS = {
  'green': {
    'bg': '#6EFF9C',
    'primary': '#064E3B',
    'btn': '#059669',
  },
  'blue': {
    'bg': '#A9C9F5',
    'primary': '#2B58D9',
    'btn': '#3B82F6',

  },
  'yellow': {
    'bg': '#FDFE7F',
    'primary': '#A35B2A',
    'btn': '#D97706',

  },
  'red': {
    'bg': '#F73E59',
    'primary': '#E1A9A9',
    'btn': '#DC2626',

  },
};


export const ORDERS = [
  {
    'key': 'DS', 'value': 'PDS',
  },
  {
    'key': 'AC', 'value': 'Accesorios',
  }, {
    'key': 'HU', 'value': 'Hunter',
  }, {
    'key': 'CC', 'value': 'Control de Calidad',
  },
];


export const ORDERS_STATUS = [
  {
    'text': 'Abiertas',
    'value': 'AB',
    'color': COLORS.green,
  },
  {
    'text': 'Anuladas',
    'value': 'AN',
    'color': COLORS.yellow,
  },
  {
    'text': 'Cerradas',
    'value': 'CE',
    'color': COLORS.red,
  },
  {
    'text': 'No facturables',
    'value': 'NF',
    'color': COLORS.blue,
  },
];

export const ORDERS_STATUS_COMPLETE = [
  {
    'text': 'Todas',
    'value': 'TO',
    'color': {
      'primary': '#000',
      'btn': '#000',
      'bg': '#D1D5DB',
    },
  },
  ...ORDERS_STATUS,
];

